 
import _ from 'underscore'
import service from '../service/recommend'
import CONSTANT from '../constant/recommend'

const getBannerByHotSaleList = ({ commit, state }, options) => {
    return new Promise((resolve, reject) => {
        return service.getBannerByHotSaleList(options).then(data => {
            if (_.isEmpty(data)) {
                resolve(data)
                commit(CONSTANT.RECOMMEND_GET_HOT_BANNER_EMPTY)
                return data
            }
            resolve(data)
            commit(CONSTANT.RECOMMEND_GET_HOT_BANNER_SUCCESS, data)
            return data
        }, e => {
            reject(e)
            commit(CONSTANT.RECOMMEND_GET_HOT_BANNER_ERROR, e)
        })
    })
}
const getProductByHotSaleList = ({ commit }, query) => {
    return new Promise((resolve, reject) => {
        return service.getProductByHotSaleList(query).then(data => {
            if (_.isEmpty(data)) {
                resolve(data)
                commit(CONSTANT.RECOMMEND_GET_HOT_PRODUCT_EMPTY)
                return data
            }
            resolve(data)
            commit(CONSTANT.RECOMMEND_GET_HOT_PRODUCT_SUCCESS, data)
            return data
        }, e => {
            reject(e)
            commit(CONSTANT.RECOMMEND_GET_HOT_PRODUCT_ERROR, e)
        })
    })
}
const getRecommendProductMoreByHotlist = ({ commit }, query) => {
    return new Promise((resolve, reject) => {
        return service.getProductByHotSaleList(query).then(data => {
            if (_.isEmpty(data)) {
                resolve(data)
                return data
            }
            resolve(data)
            commit(CONSTANT.RECOMMEND_GET_HOT_PRODUCT_MORE_SUCCESS, data)
            return data
        }, e => {
            reject(e)
        })
    })
}
export default {
    getBannerByHotSaleList,
    getProductByHotSaleList,
    getRecommendProductMoreByHotlist,
}
